export default "__VITE_ASSET__Do3pLXLW__"